import React from 'react';
import { Form, TimePicker } from 'antd';

import { trailTimeFormat } from '../../../../../consts/dates';

const StartTime = () => {
    return (
        <Form.Item label="Początek rezerwacji" name="startTime">
            <TimePicker format={trailTimeFormat} placeholder="08:00" />
        </Form.Item>
    );
};

export default StartTime;
